var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_vm._m(0),_c('el-button',{staticClass:"sure-button",attrs:{"size":"small"},on:{"click":_vm.onSure}},[_vm._v("\n    "+_vm._s(_vm.$t('common.sure'))+"\n  ")])],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-container"},[_c('img',{staticClass:"done-image",attrs:{"src":require("@/assets/done.png")}}),_c('span',{staticClass:"info-text"},[_vm._v("代发货建单已完成")])])
}]

export { render, staticRenderFns }